import HttpService from "./htttp.service";

class PropertiesService {
  getProperties = async (query, cancelToken) => {
    const endpoint = "properties";
    return await HttpService.get(endpoint, query, cancelToken);
  };

  createProperty = async (payload) => {
    const endpoint = "properties";
    return await HttpService.post(endpoint, payload);
  };

  removeProperty = async (id) => {
    const endpoint = "properties/" + id;
    return await HttpService.delete(endpoint, id);
  };

  updateProperty = async (id, payload) => {
    const endpoint = "properties/" + id;
    return await HttpService.put(endpoint, payload);
  };
}

export default new PropertiesService();
